import { getActionType } from './utils';

const initialState = {
  currentGoals: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateCurrentGoals'):
      return {
        ...state,
        currentGoals: action.currentGoals,
      };

    default:
      return state;
  }
};
